"use client";
import React, { useState } from "react";
import { AppState } from "@/store/configureStore";
import { useSelector } from "react-redux";
import {
	useAddToCart,
	useProductQuantity,
	useDeleteCartItem,
	useGroupCartProduct,
} from "..";
import { useGlobalContext } from "@/contexts/AppContext";

const useProduct = (data: any) => {
	const [isHover, setIsHover] = useState<boolean>(false);
	const { theme, drinkType } = useGlobalContext();

	const handleSvgColor = () => {
		const softColors: any = {
			dark: "#8C549A",
			light: "#540068",
		};

		const alcoholColors: any = {
			dark: "#D56C3D",
			light: "#FFE4DB",
		};

		return drinkType === "soft" ? softColors[theme] : alcoholColors[theme];
	};

	const onHover = () => {
		setIsHover(true);
	};
	const offHover = () => {
		setIsHover(false);
	};
	const { items } = useSelector((state: AppState) => state.cart);
	const groupCart = useSelector((state: AppState) => state.group_cart);
	const activeCart = groupCart?.allowShopping;

	const itemInCart = items?.find((item: any) => item?.product?.id === data?.id);
	const itemInGroupCart = groupCart?.items?.find(
		(item: any) => item?.product?.id === data?.id
	);

	const { addToCart } = useAddToCart();
	const { increaseQuantity, decreaseQuantity } = useProductQuantity();
	const {
		increaseItemQuantity,
		decreaseItemQuantity,
		deleteGroupCartItem,
		addItemToGroupCart,
	} = useGroupCartProduct();
	const { deleteCartItem } = useDeleteCartItem(data?.id);

	const handleItemIncrement = async () => {
		activeCart
			? await increaseItemQuantity(data?.id)
			: await increaseQuantity(data?.id);
	};

	const handleAddToCart = async () => {
		activeCart ? await addItemToGroupCart(data.id) : await addToCart(data?.id);
	};

	const handleItemDecrement = async () => {
		if (activeCart && itemInGroupCart?.quantity && itemInGroupCart?.quantity > 1) {
			await decreaseItemQuantity(data.id);
		} else if (activeCart && itemInGroupCart?.quantity === 1) {
			await deleteGroupCartItem(data?.id);
		} else if (itemInCart?.quantity && itemInCart.quantity > 1) {
			await decreaseQuantity(data.id);
		} else if (itemInCart?.quantity === 1) {
			await deleteCartItem();
		}
	};
	return {
		isHover,
		setIsHover,
		onHover,
		offHover,
		activeCart,
		groupCart,
		itemInCart,
		itemInGroupCart,
		handleAddToCart,
		handleItemDecrement,
		handleItemIncrement,
		handleSvgColor,
	};
};

export default useProduct;
